import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import {
  ContentContainer,
  ModalTitle,
  ButtonsContainer,
} from "./EditDiagnosisModal.styled";
import { TextInput } from "../../TextInput";
import { useTranslation } from "react-i18next";

interface EditDiagnosisModalContentProps {
  diagnosis: string;
  onSave: (diagnosis: string) => void | Promise<void>;
  onClose: () => void;
}

const EditDiagnosisModalContent: React.FC<EditDiagnosisModalContentProps> = ({
  diagnosis,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation();
  const [editedDiagnosis, setEditedDiagnosis] = useState(diagnosis);
  const [isSaving, setIsSaving] = useState(false);

  const isValid = editedDiagnosis.trim().length > 0;

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await onSave(editedDiagnosis);
      onClose();
    } catch (error) {
      console.error("Error saving diagnosis:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ContentContainer>
      <ModalTitle>{t("editDiagnosisModal.title")}</ModalTitle>

      <TextInput
        label={t("editDiagnosisModal.label")}
        fullWidth
        value={editedDiagnosis}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => setEditedDiagnosis(e.target.value)}
        placeholder={t("editDiagnosisModal.placeholder")}
        disabled={isSaving}
      />

      <ButtonsContainer>
        <Button variant="outlined" onClick={onClose} disabled={isSaving}>
          {t("editDiagnosisModal.cancelButton")}
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={isSaving || !isValid}
        >
          {isSaving ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t("editDiagnosisModal.saveButton")
          )}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default EditDiagnosisModalContent;
